@if (ls.currentLanguage) {

  @switch (mode) {
    @case ('floating') {
      <button mat-mini-fab [matMenuTriggerFor]="menu" class="background">
        <mat-icon [svgIcon]="ls.currentLanguage.flag"></mat-icon>
      </button>
      <mat-menu #menu="matMenu" xPosition="before">
        @for (l of ls.languages; track l.code) {
          <button mat-menu-item (click)="ls.setLanguage(l); ; languageChange.emit(l.code);"
                  [disabled]="ls.currentLanguage.code === l.code">
            <mat-icon [svgIcon]="l.flag"></mat-icon>
            <span>{{ l.name }}</span>
          </button>
        }
      </mat-menu>
    }
    @case ('dropdown') {
      <mat-form-field>
        <mat-select [value]="ls.currentLanguage.code"
                    (selectionChange)="ls.setLanguageByCode($event.value); languageChange.emit($event.value);">
          <mat-select-trigger>
            <div class="flex items-center gap-2">
              <mat-icon [svgIcon]="ls.currentLanguage.flag"></mat-icon>
              <span>{{ ls.currentLanguage.name }}</span>
            </div>

          </mat-select-trigger>
          @for (l of ls.languages; track l.code) {
            <mat-option [value]="l.code">
              <mat-icon [svgIcon]="l.flag"></mat-icon>
              <span>{{ l.name }}</span>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  }


}
